import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';
import { darkPageTheme } from './custom-page-theme';
import { sharedThemeOptions } from './shared';

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      background: { paper: '#252525' },
      navigation: {
        ...palettes.dark.navigation,
        background: '#252525', // Note: should be var(--bui-bg-app) but causes issues with AsyncApi card for API entities
        indicator: 'transparent',
      },
      link: '#5AABFF',
      linkHover: '#85C4FF',
      textContrast: '#F0EDE9',
      textSubtle: '#9A948E',
      textVerySubtle: '#504C48',
    },
  }),
  pageTheme: darkPageTheme,
  components: {
    ...sharedThemeOptions,
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'var(--paper-bg-overlay)',
          border: '1px solid var(--bui-border-1)',
        },
        elevation1: {
          boxShadow: 'none',
        },
        elevation2: {
          boxShadow: 'none',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: { '&:nth-of-type(odd)': { backgroundColor: '#373737' } },
      },
    },
  },
});
